// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2BVeV","select":"Header_select__3-YVn","clinic":"Header_clinic__1ywVs"};